// extracted by mini-css-extract-plugin
module.exports = {"container":"TabSelector_container__1zQro","item":"TabSelector_item__HlbNK","active":"TabSelector_active__ayDsB"};